import { SortDirection } from 'aa-ng';

export function cascadeSort<T>(
  source: T[],
  comparators: ((a: T, b: T) => number)[],
) {
  let idx = 0;
  let value = 0;
  const length = comparators.length;
  return source.sort((a: T, b: T) => {
    for (idx = 0; idx < length; idx++) {
      value = comparators[idx](a, b);
      if (value !== 0) {
        break;
      }
    }
    return value;
  });
}

export function sortHelper<T>(
  source: T[],
  direction: SortDirection,
  comparator: (a: T, b: T) => number,
) {
  if (direction !== SortDirection.None) {
    let array = [].concat(source.sort(comparator));
    if (direction === SortDirection.Descending) {
      array = [].concat(array.reverse());
    }
    return array;
  }
  return source;
}

export function numberComparator<T>(
  getValue: (obj: T) => number,
  reverse = false,
): (a: T, b: T) => number {
  if (reverse) {
    return (a, b) => (getValue(b) || 0) - (getValue(a) || 0);
  } else {
    return (a, b) => (getValue(a) || 0) - (getValue(b) || 0);
  }
}

export function stringComparator<T>(
  getValue: (obj: T) => string,
  reverse = false,
): (a: T, b: T) => number {
  if (reverse) {
    return (a, b) => (getValue(b) || '').localeCompare(getValue(a) || '');
  } else {
    return (a, b) => (getValue(a) || '').localeCompare(getValue(b) || '');
  }
}

export function dateComparator<T>(
  getValue: (obj: T) => Date,
  reverse = false,
): (a: T, b: T) => number {
  if (reverse) {
    return (a, b) =>
      (getValue(b) || new Date()).getTime() -
      (getValue(a) || new Date()).getTime();
  } else {
    return (a, b) =>
      (getValue(a) || new Date()).getTime() -
      (getValue(b) || new Date()).getTime();
  }
}
